import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center justify-center h-100 text-white text-center px-4" }
const _hoisted_2 = { class: "text-h3 mb-2" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "mx-2 text-caption font-weight-light my-span-vs"
}
const _hoisted_5 = { class: "d-flex align-center mx-2" }
const _hoisted_6 = { class: "text-center my-4 mt-n6" }
const _hoisted_7 = { class: "text-body-1" }
const _hoisted_8 = { class: "d-flex flex-wrap justify-center" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-center mx-4"
}
const _hoisted_10 = { class: "text-h6 font-weight-bold mb-1" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_Empty = _resolveComponent("Empty")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "flex-grow-1 bg-grey-lighten-4" }, {
    default: _withCtx(() => [
      (_ctx.state.project)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_img, {
              class: "align-center my-v-img",
              "max-height": "300",
              width: "100%",
              src: _ctx.getImagePath(_ctx.state.project.image),
              cover: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.state.project.name), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-h6 font-weight-light mb-2" }, " The alternatives discussed in the project are: ", -1)),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesIds, (alternativeId, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: alternativeId }, [
                        (index !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "VS"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_icon, { class: "me-1" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getAlternatives[alternativeId].icon), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getAlternatives[alternativeId].name), 1)
                        ])
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["src"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchToView('global-view'))),
                size: "x-large",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Open " + _toDisplayString(_ctx.state.project.name) + " project ", 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "text-primary text-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.state.project.description), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { style: {"overflow-x":"auto","text-align":"center"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesIds, (alternativeId, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'card-' + alternativeId + index
                            }, [
                              (index !== 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                                    _createElementVNode("small", { class: "text-grey-darken-1 font-weight-bold text-h6" }, "VS", -1)
                                  ])))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_card, {
                                "min-width": "280",
                                "max-width": "320",
                                class: "mx-2 mb-4",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_component_v_icon, { class: "text-primary me-2" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getAlternatives[alternativeId].icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getAlternatives[alternativeId].name), 1)
                                      ]),
                                      _createVNode(_component_v_avatar, {
                                        size: "56",
                                        color: "grey"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: _ctx.getImagePath(_ctx.getAlternatives[alternativeId].image)
                                          }, null, 8, _hoisted_11)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getAlternatives[alternativeId].description), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "mt-6" }, [
                          _createElementVNode("h2", { class: "text-h6 font-weight-bold" }, "Disclaimer"),
                          _createElementVNode("ul", { class: "text-caption ps-4" }, [
                            _createElementVNode("li", null, " The authors and publisher of the software cannot be held liable in any way for the consequences that may result from the use or interpretation of the information processed by the MyChoice software... "),
                            _createElementVNode("li", null, [
                              _createTextVNode(" By using the MyChoice software, users agree to explicitly cite the tool (home page "),
                              _createElementVNode("a", {
                                href: "https://ico.iate.inra.fr/MyChoice/",
                                target: "_blank"
                              }, "https://ico.iate.inra.fr/MyChoice/"),
                              _createTextVNode(")... ")
                            ])
                          ])
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_component_Empty, { key: 1 }))
    ]),
    _: 1
  }))
}